import { HiddenInputSkin } from './skins/HiddenInput.skin';
import { createSkinnedComponent } from '../../../../helpers/skin.helper';
var HiddenInput = createSkinnedComponent(HiddenInputSkin);
export { HiddenInput };